import * as type from './actionTypes';
import * as types from './types';

export const imei = (payload: types.ImeiRequestPayload): types.ImeiRequest => ({
    type: type.IMEI,
    payload,
});

export const imeiSuccess = (payload: types.ImeiSuccessPayload): types.ImeiSuccess => ({
    type: type.IMEI_SUCCESS,
    payload,
});

export const imeiFailure = (payload: types.ImeiFailurePayload): types.ImeiFailure => ({
    type: type.IMEI_FAILURE,
    payload,
});

export const port = (payload: types.PortRequestPayload): types.PortRequest => ({
    type: type.PORT,
    payload,
});

export const portSuccess = (payload: types.PortSuccessPayload): types.PortSuccess => ({
    type: type.PORT_SUCCESS,
    payload,
});

export const portFailure = (payload: types.PortFailurePayload): types.PortFailure => ({
    type: type.PORT_FAILURE,
    payload,
});

export const portResult = (payload: types.PortResultRequestPayload): types.PortResultRequest => ({
    type: type.PORT_RESULT,
    payload,
});

export const portResultSuccess = (payload: types.PortResultSuccessPayload): types.PortResultSuccess => ({
    type: type.PORT_RESULT_SUCCESS,
    payload,
});

export const portResultFailure = (payload: types.PortResultFailurePayload): types.PortResultFailure => ({
    type: type.PORT_RESULT_FAILURE,
    payload,
});

export const getCC = (payload: types.GetCCRequestPayload): types.GetCCRequest => ({
    type: type.GET_CC,
    payload,
});

export const getCCSuccess = (payload: types.GetCCSuccessPayload): types.GetCCSuccess => ({
    type: type.GET_CC_SUCCESS,
    payload,
});

export const getCCFailure = (payload: types.GetCCFailurePayload): types.GetCCFailure => ({
    type: type.GET_CC_FAILURE,
    payload,
});

export const updateCCAutoPay = (payload: types.UpdateCCAutoPayRequestPayload): types.UpdateCCAutoPayRequest => ({
    type: type.UPDATE_CC_AUTOPAY,
    payload,
});

export const updateCCAutoPaySuccess = (payload: types.UpdateCCAutoPaySuccessPayload): types.UpdateCCAutoPaySuccess => ({
    type: type.UPDATE_CC_AUTOPAY_SUCCESS,
    payload,
});

export const updateCCAutoPayFailure = (payload: types.UpdateCCAutoPayFailurePayload): types.UpdateCCAutoPayFailure => ({
    type: type.UPDATE_CC_AUTOPAY_FAILURE,
    payload,
});

export const removeCC = (payload: types.RemoveCCRequestPayload): types.RemoveCCRequest => ({
    type: type.REMOVE_CC,
    payload,
});

export const removeCCSuccess = (payload: types.RemoveCCSuccessPayload): types.RemoveCCSuccess => ({
    type: type.REMOVE_CC_SUCCESS,
    payload,
});

export const removeCCFailure = (payload: types.RemoveCCFailurePayload): types.RemoveCCFailure => ({
    type: type.REMOVE_CC_FAILURE,
    payload,
});

export const ccHold = (payload: types.CCHoldRequestPayload): types.CCHoldRequest => ({
    type: type.CC_HOLD,
    payload,
});

export const ccHoldSuccess = (payload: types.CCHoldSuccessPayload): types.CCHoldSuccess => ({
    type: type.CC_HOLD_SUCCESS,
    payload,
});

export const ccHoldFailure = (payload: types.CCHoldFailurePayload): types.CCHoldFailure => ({
    type: type.CC_HOLD_FAILURE,
    payload,
});

export const checkIcc = (payload: types.CheckIccRequestPayload): types.CheckIccRequest => ({
    type: type.CHECK_ICC,
    payload,
});

export const checkIccSuccess = (payload: types.CheckIccSuccessPayload): types.CheckIccSuccess => ({
    type: type.CHECK_ICC_SUCCESS,
    payload,
});

export const checkIccFailure = (payload: types.CheckIccFailurePayload): types.CheckIccFailure => ({
    type: type.CHECK_ICC_FAILURE,
    payload,
});

export const updateCCExpiry = (payload: types.UpdateCCExpiryRequestPayload): types.UpdateCCExpiryRequest => ({
    type: type.UPDATE_CC_EXPIRY,
    payload,
});

export const updateCCExpirySuccess = (payload: types.UpdateCCExpirySuccessPayload): types.UpdateCCExpirySuccess => ({
    type: type.UPDATE_CC_EXPIRY_SUCCESS,
    payload,
});

export const updateCCExpiryFailure = (payload: types.UpdateCCExpiryFailurePayload): types.UpdateCCExpiryFailure => ({
    type: type.UPDATE_CC_EXPIRY_FAILURE,
    payload,
});

export const addCard = (payload: types.AddCardRequestPayload): types.AddCardRequest => ({
    type: type.ADD_CARD,
    payload,
});

export const addCardSuccess = (payload: types.AddCardSuccessPayload): types.AddCardSuccess => ({
    type: type.ADD_CARD_SUCCESS,
    payload,
});

export const addCardFailure = (payload: types.AddCardFailurePayload): types.AddCardFailure => ({
    type: type.ADD_CARD_FAILURE,
    payload,
});

export const activation = (payload: types.ActivationRequestPayload): types.ActivationRequest => ({
    type: type.ACTIVATION,
    payload,
});

export const activationSuccess = (payload: types.ActivationSuccessPayload): types.ActivationSuccess => ({
    type: type.ACTIVATION_SUCCESS,
    payload,
});

export const activationFailure = (payload: types.ActivationFailurePayload): types.ActivationFailure => ({
    type: type.ACTIVATION_FAILURE,
    payload,
});

export const activationStatus = (payload: types.ActivationStatusRequestPayload): types.ActivationStatusRequest => ({
    type: type.ACTIVATION_STATUS,
    payload,
});

export const activationStatusSuccess = (
    payload: types.ActivationStatusSuccessPayload,
): types.ActivationStatusSuccess => ({
    type: type.ACTIVATION_STATUS_SUCCESS,
    payload,
});

export const activationStatusFailure = (
    payload: types.ActivationStatusFailurePayload,
): types.ActivationStatusFailure => ({
    type: type.ACTIVATION_STATUS_FAILURE,
    payload,
});

export const dataUsage = (payload: types.DataUsageRequestPayload): types.DataUsageRequest => ({
    type: type.DATA_USAGE,
    payload,
});

export const dataUsageSuccess = (payload: types.DataUsageSuccessPayload): types.DataUsageSuccess => ({
    type: type.DATA_USAGE_SUCCESS,
    payload,
});

export const dataUsageFailure = (payload: types.DataUsageFailurePayload): types.DataUsageFailure => ({
    type: type.DATA_USAGE_FAILURE,
    payload,
});

export const currentDataUsage = (payload: types.CurrentDataUsageRequestPayload): types.CurrentDataUsageRequest => ({
    type: type.CURRENT_DATA_USAGE,
    payload,
});

export const currentDataUsageSuccess = (
    payload: types.CurrentDataUsageSuccessPayload,
): types.CurrentDataUsageSuccess => ({
    type: type.CURRENT_DATA_USAGE_SUCCESS,
    payload,
});

export const currentDataUsageFailure = (
    payload: types.CurrentDataUsageFailurePayload,
): types.CurrentDataUsageFailure => ({
    type: type.CURRENT_DATA_USAGE_FAILURE,
    payload,
});

export const reachCredit = (payload: types.ReachCreditRequestPayload): types.ReachCreditRequest => ({
    type: type.REACH_CREDIT,
    payload,
});

export const reachCreditSuccess = (payload: types.ReachCreditSuccessPayload): types.ReachCreditSuccess => ({
    type: type.REACH_CREDIT_SUCCESS,
    payload,
});

export const reachCreditFailure = (payload: types.ReachCreditFailurePayload): types.ReachCreditFailure => ({
    type: type.REACH_CREDIT_FAILURE,
    payload,
});
export const getAppData = (): types.GetAppDataRequest => ({
    type: type.GET_APP_DATA,
});

export const getAppDataSuccess = (payload: types.GetAppDataSuccessPayload): types.GetAppDataSuccess => ({
    type: type.GET_APP_DATA_SUCCESS,
    payload,
});

export const getAppDataFailure = (payload: types.GetAppDataFailurePayload): types.GetAppDataFailure => ({
    type: type.GET_APP_DATA_FAILURE,
    payload,
});

export const overAll = (): types.OverAllRequest => ({
    type: type.OVER_ALL,
});

export const overAllSuccess = (payload: types.OverAllSuccessPayload): types.OverAllSuccess => ({
    type: type.OVER_ALL_SUCCESS,
    payload,
});

export const overAllFailure = (payload: types.OverAllFailurePayload): types.OverAllFailure => ({
    type: type.OVER_ALL_FAILURE,
    payload,
});

export const monthInAdvance = (payload: any) => ({
    type: type.MONTH_IN_ADVANCE,
    payload,
});

export const monthInAdvancePost = (payload: any) => ({
    type: type.MONTH_IN_ADVANCE_POST,
    payload,
});
export const monthInAdvanceSuccess = (payload: any) => ({
    type: type.MONTH_IN_ADVANCE_SUCCESS,
    payload,
});
export const monthInAdvancePostSuccess = (payload: any) => ({
    type: type.MONTH_IN_ADVANCE_POST_SUCCESS,
    payload,
});
export const monthInAdvancePostFailure = (payload: any) => ({
    type: type.MONTH_IN_ADVANCE_POST_FAILURE,
    payload,
});

export const monthInAdvanceFailure = (payload: any) => ({
    type: type.MONTH_IN_ADVANCE_FAILURE,
    payload,
});

export const monthInAdvancePostFailureReset = (payload: any) => ({
    type: type.MONTH_IN_ADVANCE_POST_FAILURE_RESET,
    payload,
});
export const resendESimKitSuccess = (payload: any) => ({
    type: type.RESEND_ESIM_KIT_SUCCESS,
    payload,
});
export const resendStatus = (payload: any) => ({
    type: type.RESEND_ESIM_KIT,
    payload,
});
export const resendESimKitFailure = (payload: any) => ({
    type: type.RESEND_ESIM_KIT_FAILURE,
    payload,
});
